// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

		// Open active sub-nav on load
	$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
	$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function() {}).addClass('menu-open');

	//Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function(event) {
		if ( $(this).parent().children(".sub-sub-menu").length > 0 ) {

            event.preventDefault();

            if ($(this).next().hasClass('menu-open')) {
                $(this).closest('.inner').removeClass('open');
                $('.navigation ul li').removeClass('item-open');
                $(this).parent().addClass('item-open');
                $(this).next().slideUp(300, function(){
                    if($('.navigation ul li a').hasClass('active')){
						$(".item-open").get(0).scrollIntoView(false);
					} 
                }).removeClass('menu-open');	                
            } else {
                $(this).closest('.inner').addClass('open');
                $('.navigation ul li').removeClass('item-open');
                $(this).parent().addClass('item-open');
                $('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open'); 
                $(this).next().addClass('menu-open').slideDown(300, function(){
                    if($('.navigation ul li a').hasClass('active')){
						$(".item-open").get(0).scrollIntoView(false);
					}
                });
            }
        }
	});

	});

	window.onload = function() {
		scrollDownAction(40, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 40){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}